var _style, _filter, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  focusable: "false",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32",
  enableBackground: "new 0 0 32 32"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{filter:url(#filter-2);} .st1{fill:#E9E9E9;} .st2{fill:#2B2B2B;}")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
  filterUnits: "objectBoundingBox",
  height: "141.7%",
  id: "filter-2",
  width: "137.5%",
  x: "-18.8%",
  y: "-10.4%"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Panel"
}, /*#__PURE__*/React.createElement("g", {
  id: "Artboard-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "path-1_2_"
}, /*#__PURE__*/React.createElement("g", {
  className: "st0"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path-1_4_",
  cx: 16,
  cy: 15,
  r: 12
})), /*#__PURE__*/React.createElement("circle", {
  id: "path-1_1_",
  className: "st1",
  cx: 16,
  cy: 15,
  r: 12
})), /*#__PURE__*/React.createElement("g", {
  id: "close",
  transform: "translate(6 5)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "path-1_3_",
  className: "st2",
  cx: 10,
  cy: 10,
  r: 10
}), /*#__PURE__*/React.createElement("path", {
  id: "Combined-Shape",
  className: "st1",
  d: "M11.3 9.9l3.5-3.5c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0L9.9 8.5 6.4 5c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3.5 3.5L5 13.4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0l3.5-3.5 3.5 3.5c.4.4 1 .4 1.4 0 .4-.4.4-1 0-1.4l-3.5-3.5z"
}))))));
export { SvgCloseIcon as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIGZvY3VzYWJsZT0iZmFsc2UiCiAgd2lkdGg9IjFlbSIKICBoZWlnaHQ9IjFlbSIKICBmaWxsPSJjdXJyZW50Q29sb3IiCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMzIgMzIiIGVuYWJsZS1iYWNrZ3JvdW5kPSJuZXcgMCAwIDMyIDMyIj4KICA8c3R5bGU+LnN0MHtmaWx0ZXI6dXJsKCNmaWx0ZXItMik7fSAuc3Qxe2ZpbGw6I0U5RTlFOTt9IC5zdDJ7ZmlsbDojMkIyQjJCO308L3N0eWxlPgogIDxmaWx0ZXIgZmlsdGVyVW5pdHM9Im9iamVjdEJvdW5kaW5nQm94IiBoZWlnaHQ9IjE0MS43JSIgaWQ9ImZpbHRlci0yIiB3aWR0aD0iMTM3LjUlIiB4PSItMTguOCUiIHk9Ii0xMC40JSI+CiAgICA8ZmVPZmZzZXQgZHk9IjMiIGluPSJTb3VyY2VBbHBoYSIgcmVzdWx0PSJzaGFkb3dPZmZzZXRPdXRlcjEiLz4KICAgIDxmZUdhdXNzaWFuQmx1ciBpbj0ic2hhZG93T2Zmc2V0T3V0ZXIxIiByZXN1bHQ9InNoYWRvd0JsdXJPdXRlcjEiIHN0ZERldmlhdGlvbj0iMSIvPgogICAgPGZlQ29sb3JNYXRyaXggaW49InNoYWRvd0JsdXJPdXRlcjEiIHZhbHVlcz0iMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMC4yNSAwIi8+CiAgPC9maWx0ZXI+CiAgPGcgaWQ9IlBhbmVsIj4KICAgIDxnIGlkPSJBcnRib2FyZC0yIj4KICAgICAgPGcgaWQ9InBhdGgtMV8yXyI+CiAgICAgICAgPGcgY2xhc3M9InN0MCI+CiAgICAgICAgICA8Y2lyY2xlIGlkPSJwYXRoLTFfNF8iIGN4PSIxNiIgY3k9IjE1IiByPSIxMiIvPgogICAgICAgIDwvZz4KICAgICAgICA8Y2lyY2xlIGlkPSJwYXRoLTFfMV8iIGNsYXNzPSJzdDEiIGN4PSIxNiIgY3k9IjE1IiByPSIxMiIvPgogICAgICA8L2c+CiAgICAgIDxnIGlkPSJjbG9zZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNiA1KSI+CiAgICAgICAgPGNpcmNsZSBpZD0icGF0aC0xXzNfIiBjbGFzcz0ic3QyIiBjeD0iMTAiIGN5PSIxMCIgcj0iMTAiLz4KICAgICAgICA8cGF0aCBpZD0iQ29tYmluZWQtU2hhcGUiIGNsYXNzPSJzdDEiIGQ9Ik0xMS4zIDkuOWwzLjUtMy41Yy40LS40LjQtMSAwLTEuNC0uNC0uNC0xLS40LTEuNCAwTDkuOSA4LjUgNi40IDVjLS40LS40LTEtLjQtMS40IDBzLS40IDEgMCAxLjRsMy41IDMuNUw1IDEzLjRjLS40LjQtLjQgMSAwIDEuNC40LjQgMSAuNCAxLjQgMGwzLjUtMy41IDMuNSAzLjVjLjQuNCAxIC40IDEuNCAwIC40LS40LjQtMSAwLTEuNGwtMy41LTMuNXoiLz4KICAgICAgPC9nPgogICAgPC9nPgogIDwvZz4KPC9zdmc+Cg==";